import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { EngagementRateCalculatorPage } from '../../../pages/tools/creator-tools/EngagementRateCalculatorPage';

export const Route = createFileRoute('/_site/tools/engagement-rate-calculator')({
  head: () => toolHead('engagement-rate-calculator'),
  component: EngagementRateCalculatorPage,
});
